import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'start', 'end', 'immediate', 'indefinite'];

  connect() {
    this.checkAvailabilityPeriod();
  }

  checkAvailabilityPeriod() {
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();

    console.log('startDate', startDate);
    console.log('endDate', endDate);
    if (startDate && endDate) {
      const startDateObj = new Date(startDate);
      const endDateObj = new Date(endDate);

      const dayDiff = (endDateObj - startDateObj) / (1000 * 60 * 60 * 24);

      // Show banner if less than or equal to 3 months (92 days) to account for months with 31 days
      dayDiff <= 91 ? this.showSeasonalBanner() : this.hideSeasonalBanner();
    } else {
      this.hideSeasonalBanner();
    }
  }

  getStartDate() {
    if (this.immediateTarget?.checked) {
      return new Date();
    }

    return this.startTarget?.value ? new Date(this.startTarget.value) : null;
  }

  getEndDate() {
    if (this.indefiniteTarget?.checked) {
      return null;
    }

    return this.endTarget?.value ? new Date(this.endTarget.value) : null;
  }

  showSeasonalBanner() {
    this.containerTarget?.classList.remove('hidden');
  }

  hideSeasonalBanner() {
    this.containerTarget?.classList.add('hidden');
  }

  dateChanged() {
    this.checkAvailabilityPeriod();
  }
}
